import {
  initialState,
  Actions,
  State,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_ERROR,
  RESET_UPDATE_CATEGORY,
} from "../../types/category/update-category";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_CATEGORY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case UPDATE_CATEGORY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };

    case RESET_UPDATE_CATEGORY:
      return initialState
    default:
      return state;
  }
};

export default reducers;
